import Box from '@mui/material/Box';
import { useTheme } from '@mui/material/styles';
import Alert from '@mui/material/Alert';
// import { Text } from '@sitecore-jss/sitecore-jss-nextjs';
import { StDTPGridContainer, StDTPWrapper } from '../..//shared/Container/Container.styles';
import { StNextImage } from '../../shared/NextImage.styles';
import { ConfirmationBannerProps } from './ConfirmationBanner.type';
import { GetServerSideComponentProps } from '@sitecore-jss/sitecore-jss-nextjs';
import { convertCdpComponentData, fetchComponentData } from '../Utils/success-page-utils';
import SuccessPageMergeTagText from '../SuccessPageMergeTag/SuccessPageMergeTagText';
import UiText from '../../shared/Typography/UiText';
import useApplyV2Theme from '../../../lib/hooks/useApplyV2Theme';

const ConfirmationBanner = (props: ConfirmationBannerProps): JSX.Element => {
  const theme = useTheme();
  const { isToapplyV2Theme } = useApplyV2Theme();
  if (!props?.fields) return <></>;
  let { fields } = props;
  // Donot show component is show is false
  const { show } = props;
  if (!show) {
    return <></>;
  }

  // show default value if fields are empty
  if (Object.keys(fields).length === 0) {
    fields = props.fields;
  }
  return (
    <StDTPWrapper>
      <StDTPGridContainer>
        <Alert
          icon={false}
          sx={{
            width: '100%',
            padding: 0,
            borderRadius: '8px',
            background: '#028602',
            marginBlock: '1rem',
            '& .MuiAlert-message': {
              textAlign: 'center',
              width: 'inherit',
              paddingBlock: '15px',
            },
          }}
        >
          <Box sx={{ display: 'flex', justifyContent: 'center', gap: '0.5rem' }}>
            <StNextImage
              suppressHydrationWarning
              field={props?.fields?.bannerIcon}
              overrideIconColor={theme.palette.white.main}
            />
            {isToapplyV2Theme ? (
              <Box sx={{ marginTop: '-4px' }}>
                <UiText size="body" color="white" align="center" bold>
                  <SuccessPageMergeTagText
                    mergeTagField={fields.bannerText}
                    mergeTagObj={props.mergeTagData}
                    inheritLinkColor={true}
                  />
                </UiText>
              </Box>
            ) : (
              <Box
                sx={{
                  fontFamily: `${theme?.palette?.primaryFontFamilyType || 'Proxima Nova'} Regular`,
                  fontSize: '1rem',
                  fontWeight: 600,
                  lineHeight: '1rem',
                  color: theme.palette.white.main,
                }}
              >
                <SuccessPageMergeTagText
                  mergeTagField={fields.bannerText}
                  mergeTagObj={props.mergeTagData}
                  inheritLinkColor={true}
                />
              </Box>
            )}
          </Box>
        </Alert>
      </StDTPGridContainer>
    </StDTPWrapper>
  );
};

export default ConfirmationBanner;

export const getServerSideProps: GetServerSideComponentProps = async (
  context: any,
  layoutData: any
) => {
  if (layoutData?.sitecore?.context?.pageEditing) {
    return { show: true };
  }
  const cdpData = layoutData?.sitecore?.context?.CDP as any;
  const cdpComponentData = convertCdpComponentData(cdpData.componentData);
  const language = context?.language || process.env.DEFAULT_LANGUAGE || 'en';

  //Modify component props based on CDP output
  const componentProps = await fetchComponentData(
    cdpComponentData,
    language,
    cdpData.componentsToHide,
    'ConfirmationBanner'
  );

  return {
    ...componentProps,
    mergeTagData: cdpData,
  };
};
